/**
 * Header Module
 * Handles sticky header with compact state on scroll
 */

let isScrolled = false;

export function initHeader() {

    const header = document.getElementById('site-header');
    if (!header) {
        return;
    }

    // Handle scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll(header);
                ticking = false;
            });
            ticking = true;
        }
    });

    // Initial check
    handleScroll(header);
}

function handleScroll(header) {
    const scrollTop = window.scrollY;

    if (scrollTop > 50 && !isScrolled) {
        header.classList.add('scrolled');
        isScrolled = true;
    } else if (scrollTop <= 50 && isScrolled) {
        header.classList.remove('scrolled');
        isScrolled = false;
    }
}

/**
 * Get header height (useful for other modules)
 */
export function getHeaderHeight() {
    const header = document.getElementById('site-header');
    return header ? header.offsetHeight : 0;
}
